import { useLocation } from "react-router-dom";

import { ForwardIcon } from "../../assets/DirectTopUpIcon";

export const Header = () => {
  const location = useLocation();

  // Extract the last path segment as the category key
  const path = location.pathname;
  const segments = path.split("/").filter(Boolean); // ["products", "data", "MTN"]
  const formattedProduct =
    segments.length >= 2 ? segments[segments.length - 2].toUpperCase() : "";
  const formattedProvider =
    segments.length >= 1 ? segments[segments.length - 1] : "";

  return (
    <div className=" mt-2 lg:mt-2 flex items-center gap-2 dark:text-white text-[9px] bp:text-xs mb-6 font-satoshi font-semibold">
      <p>Products Details</p>
      <ForwardIcon />
      <p>{formattedProduct}</p>
      <ForwardIcon />
      <p>{formattedProvider}</p>
    </div>
  );
};
